import Component from 'umg-ember-backend/components/record-explorer';

export default class RecordExplorerForCalendarEventComponent extends Component {
  // Defaults
  availableFilters = [
    ...this.defaultFilters,
    {
      key: 'categoryId1',
      options: [215, 217, 216, 218],
      type: 'selectValueLabel',
    },
  ];

  defaultColumns = [
    'id',
    'startDate',
    'artists',
    'calendarTypeId',
    'headline',
    'cmsState',
    'cmsModified',
  ];

  tableColumns = [
    {
      property: 'id',
      sortable: true,
    },
    {
      property: 'headline',
      isMainColumn: true,
    },
    {
      property: 'calendarTypeId',
      type: 'relation',
    },
    {
      property: 'startDate',
      sortable: true,
      type: 'date',
      format: 'L',
      align: 'right',
    },
    {
      property: 'artists',
      type: 'relation',
    },
    {
      property: 'cmsState',
      sortable: true,
      type: 'translate-value',
      align: 'right',
    },
    {
      property: 'cmsModified',
      sortable: true,
      type: 'date',
      format: 'L LT',
      align: 'right',
    },
    {
      property: 'cmsCreated',
      sortable: true,
      type: 'date',
      format: 'L LT',
      align: 'right',
    },
  ];
}
